import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tab - A wrapper that renders a standard HTML li for Bulma tabs
 * 
 * This component accepts the same props as Bloomer Tab for easy migration
 */
const Tab = ({
  className,
  style,
  isActive,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = [];
    
    // Add appropriate classes based on props
    if (isActive) {
      classes.push('is-active');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <li 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </li>
  );
};

Tab.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isActive: PropTypes.bool,
  children: PropTypes.node
};

Tab.defaultProps = {
  className: '',
  style: {},
  isActive: false,
  children: null
};

export default Tab;
